import { Box, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';

function EmptyHistory() {
  return (
    <Box flex={1} paddingTop="space-200">
      <Text
        locNS="account"
        locKey="emptyHistoryMessage"
        variant="body-m"
        color="darkSurfacePrimary"
        textAlign="center"
      />
    </Box>
  );
}

export default memo(EmptyHistory);
